import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import { NavLink, Link } from 'react-router-dom';
import axios from 'axios';
import { AUTH_CONFIG } from '../Auth/auth0-variables';
import 'intro.js/introjs.css';
import { Steps } from 'intro.js-react';
import { toggleNav, profilePage } from "../actions"
import {
    Board28Regular, DataBarVertical24Regular, Chat24Regular,ClipboardCheckmark24Regular, Notepad24Regular, LearningApp24Regular, CalendarRtl28Regular, PersonQuestionMark24Regular, Settings28Regular, Shifts28Regular, Clock28Regular, TaskListSquareLtr24Regular, Rocket24Regular
} from '@fluentui/react-icons';
import ShiftsContext from '../Context/ShiftsContext'
import { USE_NEW_NAV } from '../Context/ShiftsContext';
import {
    Clock20Regular, Calendar20Regular, People20Regular,CalendarClock24Regular,DocumentSearch24Regular,MailInbox24Regular,ShiftsActivity24Regular,HatGraduation24Regular, ClipboardTextLtr24Regular, PersonFeedback20Regular, BuildingShop20Regular, ReceiptMoney20Regular, PersonSettings20Regular, PeopleTeam28Regular, ContentSettings20Regular
} from '@fluentui/react-icons';
import {
    Shifts20Regular, ShiftsTeam20Regular, ShiftsOpen20Regular, TextBulletListSquareWarning20Regular,
    PersonClock20Regular, PeopleSwap20Regular, LayerDiagonalPerson20Regular, PeopleList20Regular, ClockToolbox20Regular, PersonNote20Regular,
    CalendarDataBar20Regular, CalendarPerson20Regular, CalendarClock20Regular, DocumentOnePageSparkle20Regular, DocumentData20Regular,
    PeopleTeam20Regular, TasksApp20Regular, Feed20Regular, DocumentPercent20Regular, DocumentCheckmark20Regular,
    Call20Regular, Alert20Regular, ShiftsActivity20Regular
} from '@fluentui/react-icons';
import $ from 'jquery'
import { withRouter } from 'react-router-dom';
import { EmployeeNav } from './EmployeeNav';
import AdminNav from './AdminNav';

class NavMenu extends Component {
    static contextType = ShiftsContext

    constructor(props) {
        super(props);
        this.state = {
            stepsEnabled: false,
            initialStep: 0,
            ActivePosition: 0,
            time: this.props.TimesheetModule,
            ScheduleModule: this.props.ScheduleModule,
            TimesheetModule: this.props.TimesheetModule,
            CoursesModule: this.props.CoursesModule,
            AuditsModule: this.props.AuditsModule,
            FormsModule: this.props.FormsModule,
            TasksModule: this.props.TasksModule,
            steps: [
                {
                    element: '.stafff',
                    intro: "Let's start by adding a few employees to your account. Click here to add them.",
                    position: 'right',
                    tooltipClass: 'myTooltipClass',
                    highlightClass: 'myHighlightClass',
                },
                {
                    element: '.world',
                    intro: 'World step',
                },
            ],
        }
    }

    onExit = () => {
        this.setState(() => ({ stepsEnabled: false }));
    };

    toggleNav = () => {
        this.props.dispatch(toggleNav(!this.props.closeNav));
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ScheduleModule !== this.props.ScheduleModule) {
            this.setState({
                ScheduleModule: nextProps.ScheduleModule
            })
        }
        if (nextProps.TimesheetModule !== this.props.TimesheetModule) {
            this.setState({
                TimesheetModule: nextProps.TimesheetModule
            })
        }
        if (nextProps.CoursesModule !== this.props.CoursesModule) {
            this.setState({
                CoursesModule: nextProps.CoursesModule
            })
        }
        if (nextProps.AuditsModule !== this.props.AuditsModule) {
            this.setState({
                AuditsModule: nextProps.AuditsModule
            })
        }
        if (nextProps.FormsModule !== this.props.FormsModule) {
            this.setState({
                FormsModule: nextProps.FormsModule
            })
        }
        if (nextProps.TasksModule !== this.props.TasksModule) {
            this.setState({
                TasksModule: nextProps.TasksModule
            })
        }

    }

    setNavHover = () => {
        // Get all sidebar items
        const sidebarItems = document.querySelectorAll('.sidebar-item');
        sidebarItems.forEach(function (item) {
            let hoverTimer;
            const navTag = item.querySelector('.nav-tag'); // Get the nav-tag inside the sidebar-item

            // When mouse enters the sidebar item
            item.addEventListener('mouseenter', function () {
                hoverTimer = setTimeout(function () {
                    navTag && navTag.classList.add('is-visible'); // Add the 'is-visible' class to show the nav-tag
                }, 0); // 1-second delay
            });

            // When mouse leaves the sidebar item
            item.addEventListener('mouseleave', function () {
                clearTimeout(hoverTimer);
                navTag && navTag.classList.remove('is-visible'); // Remove the 'is-visible' class to hide the nav-tag
            });

            // When a link inside the sidebar item is clicked
            const links = item.querySelectorAll('a');
            links.forEach(function (link) {
                link.addEventListener('click', function () {
                    navTag && navTag.classList.remove('is-visible'); // Remove the 'is-visible' class
                });
            });
        });
    }

    setSubMenuPositioning = () => {
        const items = document.querySelectorAll('.sidebar-item.has-sub');
        items.forEach(function (item) {
            item.addEventListener('mouseenter', function () {
                const subMenu = item.querySelector('.sub-menu');
                if (!subMenu) return;
                // Reset position first so we can measure natural height
                subMenu.style.top = '0px';
                const itemRect = item.getBoundingClientRect();
                const menuHeight = subMenu.scrollHeight;
                const viewportHeight = window.innerHeight;
                const padding = 10;
                // The sub-menu is absolutely positioned relative to its parent .sidebar-item
                // Its natural top:0 aligns it with the top of the sidebar-item
                // Calculate how far the bottom of the menu extends past the viewport
                const menuBottom = itemRect.top + menuHeight;
                if (menuBottom > viewportHeight - padding) {
                    // Shift up so the menu bottom sits at the viewport bottom with padding
                    const offset = menuBottom - (viewportHeight - padding);
                    subMenu.style.top = -offset + 'px';
                }
            });
        });
    }

    componentDidMount() {
        this.setNavHover();
        this.setSubMenuPositioning();
       
        // check if seen walkthrough
        axios.get(AUTH_CONFIG.API_URL + "/api/Account/CheckWalkThroughSeen").then((response) => {
            if (!response.data) {
                this.setState({
                    stepsEnabled: true
                })
            }
        });

        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetShiftRequestCount?facilityId=" + this.props.facilityId)
            .then((response) => {
                if (response.data > 1) {
                    $("#RequestCount").append('<div class="ring-container"><div class="ringring"></div><div class="circle"></div></div>');
                }
            });

        if (this.props.type == 'scheduler' && this.props.user.userType == '3') {
            axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetShiftSwapOffers")
                .then((response) => {
                    if (response.data > 0) {
                        $("#eRequestCount").append('<div class="ring-container"><div class="ringring"></div><div class="circle"></div></div>');
                    }
                });
        }
    }

    handleClickOpen = (page) => {
        this.props.dispatch(profilePage(page))
    };

    schedulerClick = () => {
        const { scheduleType, refreshVisibleData, filteredShifts, hardRefreshShifts } = this.context
        debugger;
        if (filteredShifts.length === 0) {
            hardRefreshShifts()
        }
        this.props.history.push("/scheduler/schedule/" + scheduleType);
        refreshVisibleData(scheduleType);
    }

    getTop = (id, height) => {
        

    }


    render() {
        const isAdmin = this.props.user.userType == '1' || this.props.user.userType == '2';
        return (
            <Fragment>
                {/* New admin nav renders OUTSIDE the old sidebar wrapper */}
                {isAdmin && USE_NEW_NAV &&
                    <AdminNav
                        logoSrc={this.props.logoSrc}
                        clientName={this.props.clientName}
                        modules={{
                        ScheduleModule: this.state.ScheduleModule,
                        TimesheetModule: this.state.TimesheetModule,
                        CoursesModule: this.state.CoursesModule,
                        AuditsModule: this.state.AuditsModule,
                        FormsModule: this.state.FormsModule,
                        TasksModule: this.state.TasksModule,
                    }} />
                }
                {/* Old sidebar: hidden for admin when new nav is active, visible for employees always */}
                {!(isAdmin && USE_NEW_NAV) &&
                <nav className="sidebar">
                
                    {this.props.user.userType == "3" &&
                    <EmployeeNav />
                        //<div className="displayflex height100 flexcolumn" style={{ justifyContent: 'space-between' }}>
                        //    <ul className="sidebar__items">

                        //        <li className="sidebar-item">
                        //            <NavLink className="sidebar-item__link" to={`/scheduler/my-schedule`} activeClassName="is-active" exact>
                        //                <CalendarRtl28Regular />
                        //                <span className="sidebar-item__text" title="">Schedule</span>
                        //            </NavLink>
                        //        </li>
                        //        {this.state.AuditsModule &&
                        //            <li className="sidebar-item">
                        //                <NavLink className="sidebar-item__link" to={`/admin/overview/audits`} activeClassName="is-active">
                        //                    <ClipboardCheckmark24Regular />
                        //                    <span className="sidebar-item__text" title="">Audits</span>
                        //                </NavLink>
                        //            </li>
                        //        }
                        //        {this.state.AuditsModule &&
                        //            <li className="sidebar-item">
                        //                <NavLink className="sidebar-item__link" to={`/user/forms`} activeClassName="is-active">
                        //                    <Notepad24Regular />
                        //                    <span className="sidebar-item__text" title="">Audits</span>
                        //                </NavLink>
                        //            </li>
                        //        }
                        //        <li className="sidebar-item" id="eRequestCount">
                        //            <NavLink className="sidebar-item__link" to={`/schedule/requests`} activeClassName="is-active" >
                        //                <PersonQuestionMark24Regular />
                        //                <span className="sidebar-item__text" title="">Requests</span>
                        //            </NavLink>
                        //        </li>
                        //        <li className="sidebar-item">
                        //            <NavLink className="sidebar-item__link" to={`/scheduler/colleagues`} activeClassName="is-active" exact>
                        //                <PeopleTeam28Regular />
                        //                <span className="sidebar-item__text" title="">Colleagues</span>
                        //            </NavLink>
                        //        </li>
                        //        <li className="sidebar-item">
                        //            <NavLink className="sidebar-item__link" to={`/chats`} activeClassName="is-active">
                        //                <Chat24Regular />
                        //                <span className="sidebar-item__text" title="">Messages</span>
                        //            </NavLink>
                        //        </li>

                        //    </ul>
                        //    <ul className="sidebar__items">
                        //        <li className="sidebar-item bottom" >
                        //            <a className="sidebar-item__link">
                        //                <i class="ms-Icon ms-Icon--Unknown" title="Help" aria-hidden="true"></i>
                        //                <span className="sidebar-item__text" title="">Help</span>
                        //                <ul className="sub-menu  pt20 pb10" style={{ top: -60 }}>
                        //                    <h4>Help</h4>
                        //                    <li className="link-row" >
                        //                        <a className="link" onClick={() => this.handleClickOpen(6)}> <i className="ms-Icon ms-Icon--Chat"></i> Contact support</a>
                        //                    </li>
                        //                    <li className="link-row" >
                        //                        <a className="link" onClick={() => this.handleClickOpen(7)}><i className="ms-Icon ms-Icon--Comment"></i> Suggest a feature</a>
                        //                    </li>
                        //                </ul>
                        //            </a>

                        //            {this.props.closeNav &&
                        //                <a className="sidebar-item__link" style={{ height: 56 }} onClick={() => this.toggleNav()}>
                        //                    <i class="ms-Icon ms-Icon--DoubleChevronRight" ></i>
                        //                </a>
                        //            }
                        //        </li>
                        //    </ul>
                        //</div>
                    }
                    {(this.props.user.userType == '1' || this.props.user.userType == '2') &&
                        <div className="displayflex height100 flexcolumn" style={{ justifyContent: 'space-between' }}>

                            <ul className="sidebar__items">
                                {!this.props.clientSettings?.quickStartDone &&
                                    <li className="sidebar-item">
                                        <NavLink className="sidebar-item__link" to={`/quickstart`} activeClassName="is-active" exact>
                                            <Rocket24Regular />
                                            <span className="sidebar-item__text" title="">Quick Start</span>
                                            <div className="nav-tag white-to-grey">Quick Start</div>
                                        </NavLink>
                                    </li>
                                }
                                <li className="sidebar-item">
                                    <NavLink className="sidebar-item__link" to={`/scheduler/overview`} activeClassName="is-active" exact>
                                        <Board28Regular />
                                        <span className="sidebar-item__text" title="">Overview</span>
                                        <div className="nav-tag white-to-grey">Overview</div>
                                    </NavLink>
                                </li>
                                {this.state.ScheduleModule &&
                                    <>
                                        <li className="sidebar-item has-sub">
                                            <a href="" className={` sidebar-item__link ${window.location.pathname.indexOf('scheduler/schedule') > -1 ? 'is-active' : ''}`} onClick={(e) => { e.preventDefault(); this.schedulerClick(); }} >
                                                <CalendarRtl28Regular />
                                            <span className="sidebar-item__text" title="">Schedule</span>
                                            <div className="nav-tag white-to-grey">Schedule</div>
                                        </a>
                                       
                                        </li>
                                    <li className="sidebar-item has-sub" id="ShiftBlock" data-tour="staffing-setup">
                                            <NavLink className="sidebar-item__link" to={`/scheduler/shifts/shift-types`} activeClassName="is-active">
                                                <CalendarClock24Regular />
                                                <span className="sidebar-item__text" title="">Shifts</span>
                                                <div className="nav-tag white-to-grey">Shifts</div>
                                            </NavLink>
                                            <ul className="sub-menu  pt20 pb10" id="ShiftSub">
                                                <h4>Shifts</h4>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/shifts`} activeClassName="is-active"><Shifts20Regular className="mr5" /> Staffing Needs</NavLink>
                                                </li>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/shifts/shift-types`} activeClassName="is-active"><ShiftsActivity20Regular className="mr5" /> Shift Types</NavLink>
                                                </li>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/shifts/templates`} activeClassName="is-active"><ShiftsTeam20Regular className="mr5" /> Schedule Templates</NavLink>
                                                </li>
                                                <h4 style={{ marginTop: 30 }}>Open Shift Alerts</h4>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/shifts/shiftalert/create`} activeClassName="is-active"><ShiftsOpen20Regular className="mr5" /> Create Shift Alert</NavLink>
                                                </li>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/shifts/shiftalerts`} activeClassName="is-active"><TextBulletListSquareWarning20Regular className="mr5" /> Shift Alerts</NavLink>
                                                </li>
                                        </ul>
                                       
                                        </li>

                                    <li className="sidebar-item has-sub" id="RequestCount" data-tour="employee-requests">
                                            <NavLink className="sidebar-item__link" to={`/scheduler/requests`} activeClassName="is-active">
                                                <MailInbox24Regular />
                                            <span className="sidebar-item__text" title="">Requests</span>
                                            <div className="nav-tag white-to-grey">Requests</div>
                                            </NavLink>
                                            <ul className="sub-menu  pt20 pb10">
                                                <h4>Requests</h4>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/requests`} activeClassName="is-active"><PersonClock20Regular className="mr5" /> To Work</NavLink>
                                                </li>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/requests/swap`} activeClassName="is-active"><PeopleSwap20Regular className="mr5" /> Swap Shift</NavLink>
                                                </li>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/requests/availability`} activeClassName="is-active"><LayerDiagonalPerson20Regular className="mr5" /> Availability Change</NavLink>
                                                </li>

                                                <h4 style={{ marginTop: 30 }}>Availability</h4>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/requests/users-availability`} activeClassName="is-active"><PeopleList20Regular className="mr5" /> Users Availability</NavLink>
                                                </li>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/requests/my-availability`} activeClassName="is-active"><PersonNote20Regular className="mr5" /> My Availability</NavLink>
                                                </li>

                                                <h4 style={{ marginTop: 30 }}>Time Off</h4>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/requests/pto`} activeClassName="is-active"><Clock20Regular className="mr5" /> Time Off Requests</NavLink>
                                                </li>
                                                <li className="link-row" >
                                                    <NavLink className="link" to={`/scheduler/requests/policies`} activeClassName="is-active"><ClockToolbox20Regular className="mr5" /> Time Off Policies</NavLink>
                                                </li>
                                        </ul>
                                        
                                        </li>
                                    </>
                                }
                                <li className="sidebar-item">
                                    <NavLink className="sidebar-item__link" to={`/scheduler/users`} activeClassName="is-active">
                                        <PeopleTeam28Regular />
                                        <span className="sidebar-item__text" title="">Staff</span>
                                        <div className="nav-tag white-to-grey">Staff</div>
                                    </NavLink>
                                </li>

                                <li className="sidebar-item">
                                    <NavLink className="sidebar-item__link" to={`/chats`} activeClassName="is-active">
                                        <Chat24Regular />
                                        <span className="sidebar-item__text" title="">Messages</span>
                                        <div className="nav-tag white-to-grey">Messages</div>
                                    </NavLink>
                                    
                                </li>

                                {this.state.TimesheetModule &&
                                    <li className="sidebar-item">
                                        <NavLink className="sidebar-item__link" to={`/timesheets`} activeClassName="is-active">
                                            <ShiftsActivity24Regular />
                                            <span className="sidebar-item__text" title="">Time</span>
                                            <div className="nav-tag white-to-grey">Timesheets</div>
                                        </NavLink>
                                    </li>
                                }

                                {this.state.CoursesModule &&
                                    <li className="sidebar-item">
                                        <NavLink className="sidebar-item__link" to={`/quiz/overview`} activeClassName="is-active">
                                            <HatGraduation24Regular />
                                            <span className="sidebar-item__text" title="">Courses</span>
                                            <div className="nav-tag white-to-grey">Quizzes</div>
                                        </NavLink>
                                    </li>
                                }
                                {this.state.FormsModule &&
                                    <li className="sidebar-item">
                                        <NavLink className="sidebar-item__link" to={`/forms`} activeClassName="is-active">
                                            <ClipboardTextLtr24Regular />
                                            <span className="sidebar-item__text" title="">Forms</span>
                                            <div className="nav-tag white-to-grey">Forms</div>
                                        </NavLink>
                                    </li>
                                }
                                {this.state.AuditsModule &&
                                    <li className="sidebar-item">
                                        <NavLink className="sidebar-item__link" to={`/audits`} activeClassName="is-active">
                                            <DocumentSearch24Regular />
                                            <span className="sidebar-item__text" title="">Audits</span>
                                            <div className="nav-tag white-to-grey">Audits</div>
                                        </NavLink>
                                    </li>
                                }
                                {this.state.TasksModule &&
                                    <li className="sidebar-item">
                                        <NavLink className="sidebar-item__link" to={`/tasks`} activeClassName="is-active">
                                            <TaskListSquareLtr24Regular />
                                            <span className="sidebar-item__text" title="">Tasks</span>
                                            <div className="nav-tag white-to-grey">Tasks</div>
                                        </NavLink>
                                    </li>
                                }
                                {(this.state.ScheduleModule || this.state.AuditsModule || this.state.TasksModule) &&
                                    <li className="sidebar-item has-sub">
                                        <NavLink className="sidebar-item__link" to={`/reports`} activeClassName="is-active">
                                            <DataBarVertical24Regular />
                                            <span className="sidebar-item__text" title="">Reports</span>
                                            <div className="nav-tag white-to-grey">Reports</div>
                                        </NavLink>
                                        <ul className="sub-menu pt20 pb10">
                                            <h4>Schedule Reports</h4>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports`} activeClassName="is-active"><CalendarDataBar20Regular className="mr5" /> Schedule Summary</NavLink>
                                            </li>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/schedule/position-summary`} activeClassName="is-active"><CalendarPerson20Regular className="mr5" /> Role Summary</NavLink>
                                            </li>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/schedule/hours-scheduled`} activeClassName="is-active"><CalendarClock20Regular className="mr5" /> Hours Scheduled</NavLink>
                                            </li>
                                            <h4 style={{ marginTop: 30 }}>Quiz Reports</h4>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/quiz`} activeClassName="is-active"><DocumentOnePageSparkle20Regular className="mr5" /> Quiz</NavLink>
                                            </li>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/lessons`} activeClassName="is-active"><DocumentData20Regular className="mr5" /> Lesson</NavLink>
                                            </li>
                                            <h4 style={{ marginTop: 30 }}>Feedback</h4>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/feedback`} activeClassName="is-active"><PersonFeedback20Regular className="mr5" /> Shift Feedback</NavLink>
                                            </li>
                                            <h4 style={{ marginTop: 30 }}>User Level Reports</h4>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/user-level/forms`} activeClassName="is-active"><PeopleTeam20Regular className="mr5" /> Forms</NavLink>
                                            </li>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/user-level/audits`} activeClassName="is-active"><TasksApp20Regular className="mr5" /> Audits</NavLink>
                                            </li>
                                            <h4 style={{ marginTop: 30 }}>Audit Reports</h4>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/audit/summary`} activeClassName="is-active"><Feed20Regular className="mr5" /> Summary</NavLink>
                                            </li>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/audit/scores`} activeClassName="is-active"><DocumentPercent20Regular className="mr5" /> Scores</NavLink>
                                            </li>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/audit/completions`} activeClassName="is-active"><DocumentCheckmark20Regular className="mr5" /> Completions</NavLink>
                                            </li>
                                            <h4 style={{ marginTop: 30 }}>Task Reports</h4>
                                            <li className="link-row" >
                                                <NavLink className="link" to={`/reports/tasks`} activeClassName="is-active"><TasksApp20Regular className="mr5" /> Task Completion</NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                }
                            </ul>
                            <ul className="sidebar__items">
                                <li className="sidebar-item has-sub botttom" >
                                    <NavLink className="sidebar-item__link" to={`/settings`} activeClassName="is-active">
                                        <Settings28Regular />
                                        <span className="sidebar-item__text" title="">Settings</span>
                                        <div className="nav-tag white-to-grey">Settings</div>
                                    </NavLink>
                                    <ul className="sub-menu  pt20 pb10">
                                        <h4>Settings</h4>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings`} activeClassName="is-active"><BuildingShop20Regular className="mr5" /> Company Details</NavLink>
                                        </li>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings/invoices`} activeClassName="is-active"><ReceiptMoney20Regular className="mr5" /> Plan & Billing</NavLink>
                                        </li>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings/roles`} activeClassName="is-active"><PersonSettings20Regular className="mr5" /> Departments/Roles</NavLink>
                                        </li>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings/modules`} activeClassName="is-active"><ContentSettings20Regular className="mr5" /> Modules on/off</NavLink>
                                        </li>
                                        <h4 style={{ marginTop: 30 }}>Feedback</h4>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings/feedback`} activeClassName="is-active"><PersonFeedback20Regular className="mr5" /> Shift Feedback</NavLink>
                                        </li>
                                        <h4 style={{ marginTop: 30 }}>Timesheets</h4>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings/timesheets`} activeClassName="is-active"><Clock20Regular className="mr5" /> Time Tracking</NavLink>
                                        </li>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings/overtime`} activeClassName="is-active"><People20Regular className="mr5" /> Overtime & Breaks</NavLink>
                                        </li>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings/enforcements`} activeClassName="is-active"><Calendar20Regular className="mr5" /> Enforcements</NavLink>
                                        </li>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings/oncall`} activeClassName="is-active"><Call20Regular className="mr5" /> On-Call Shifts</NavLink>
                                        </li>
                                        <h4 style={{ marginTop: 30 }}>My Settings</h4>
                                        <li className="link-row" >
                                            <NavLink className="link" to={`/settings/notifications-alerts`} activeClassName="is-active"><Alert20Regular className="mr5" /> Notifications & Alerts</NavLink>
                                        </li>
                                    </ul>
                                </li>
                                {this.props.closeNav && <li className="sidebar-item has-sub botttom">
                                        <a className="sidebar-item__link" style={{ height: 56 }} onClick={() => this.toggleNav()}>
                                            <i class="ms-Icon ms-Icon--DoubleChevronRight" ></i>
                                        </a>
                                </li>}
                            </ul>
                        </div>
                    }

                </nav>
                }
            </Fragment>

        );
    }
}

const mapStateToProps = state => ({
    facilityId: state.appState.product.facility.facilityID,
    user: state.userProfile,
    closeNav: state.rootReducer.closeNav,
    clientSettings: state.appState.clientSettings,
    ScheduleModule: state.appState.clientSettings.scheduleModule,
    TimesheetModule: state.appState.clientSettings.timesheetModule,
    CoursesModule: state.appState.clientSettings.coursesModule,
    AuditsModule: state.appState.clientSettings.auditsModule,
    FormsModule: state.appState.clientSettings.formsModule,
    TasksModule: state.appState.clientSettings.tasksModule,
});
export default withRouter(connect(mapStateToProps)(NavMenu));